'use strict';

var Log = require('../../../../log/Log');
var log = Log.channel('CmdWebSocket');
var driverLog = Log.channel('CmdWebSocket', 'driver');

var ReadyState = {
    CONNECTING: 0,
    OPEN: 1,
    CLOSING: 2,
    CLOSED: 3,
};

function CmdWebSocket(name, ipAddress, port, urlPath, dataFormat) {
    this.name = name;
    this.ipAddress = ipAddress;
    this.port = port;
    this.urlPath = urlPath;
    this.dataFormat = typeof dataFormat === 'undefined' ? 'raw' : dataFormat;
    this.fullUrl = 'ws://' + ipAddress;

    if (typeof port !== 'undefined' && port !== null) {
        this.fullUrl += ':' + port;
    }

    if (typeof urlPath !== 'undefined' && urlPath !== null) {
        this.fullUrl += '/' + urlPath;
    }

    this.destroyed = false;
    this.webSocket = null;
    this.openTimeout = null;

    this.client = {};
    this.client.onConnectResult = null;
    this.client.onReceiveCommand = null;
    this.client.onConnectionLost = null;
}

CmdWebSocket.prototype.name = 'Illudium Q-36 Explosive Space Modulator';
CmdWebSocket.prototype.onOpenTimeoutMs = 5000;

CmdWebSocket.prototype.broadcastConnectResult = function(result) {
    if (result.state === 'succeeded') {
        log.debug(this + ': successfully connected to ' + this.fullUrl);
    } else {
        log.debug(this + ': failed connecting to ' + this.fullUrl);
    }

    if (this.client.onConnectResult) {
        this.client.onConnectResult(result);
    }
};

CmdWebSocket.prototype.connect = function(onConnectResult, onReceiveCommand,
    onConnectionLost) {
    log.debug(this + ': connecting to ' + this.fullUrl);

    this.client.onConnectResult = onConnectResult;
    this.client.onReceiveCommand = onReceiveCommand;
    this.client.onConnectionLost = onConnectionLost;

    this.openTimeout = window.setTimeout(
        this.onOpenTimeoutExpired.bind(this), this.onOpenTimeoutMs);
    this.webSocket = new WebSocket(this.fullUrl);
    this.webSocket.onopen = this.onOpen.bind(this);
    this.webSocket.onclose = this.onClose.bind(this);
    this.webSocket.onerror = this.onError.bind(this);
    this.webSocket.onmessage = this.onMessage.bind(this);
};

CmdWebSocket.prototype.destroy = function() {
    this.destroyed = true;

    if (this.openTimeout !== null) {
        window.clearTimeout(this.openTimeout);
        this.openTimeout = null;
    }

    if (this.webSocket !== null &&
        (this.webSocket.readyState === ReadyState.CONNECTING ||
         this.webSocket.readyState === ReadyState.OPEN)) {
        this.webSocket.close();
    }
};

CmdWebSocket.prototype.onClose = function(event) {
    if (this.destroyed) return;

    log.debug(this + ': connection closed to ' + this.fullUrl);

    if (this.openTimeout !== null) {
        window.clearTimeout(this.openTimeout);
        this.openTimeout = null;
        this.broadcastConnectResult({
            state: 'failed',
        });
    } else {
        if (this.client.onConnectionLost) {
            this.client.onConnectionLost();
        }
    }
};

CmdWebSocket.prototype.onError = function(event) {
    // don't log errors since they don't contain any information in the websocket implementation
    //log.warning(this + ': error: ' + event.type);
};

CmdWebSocket.prototype.onMessage = function(event) {
    driverLog.debug(this + ': received: ' + event.data);

    if (!this.client.onReceiveCommand) return;

    var data = event.data;

    if (this.dataFormat === 'json') {
        data = JSON.parse(data);
    }

    this.client.onReceiveCommand(data);
};

CmdWebSocket.prototype.onOpen = function(event) {
    window.clearTimeout(this.openTimeout);
    this.openTimeout = null;

    this.broadcastConnectResult({
        state: 'succeeded',
    });
};

CmdWebSocket.prototype.onOpenTimeoutExpired = function() {
    this.openTimeout = null;
    this.broadcastConnectResult({
        state: 'failed',
    });
    this.destroy();
};

CmdWebSocket.prototype.send = function(data) {
    var sendData = data;

    if (this.dataFormat === 'json') {
        sendData = JSON.stringify(sendData);
    }

    driverLog.debug(this + ': sent: ' + sendData);
    this.webSocket.send(sendData);
};

CmdWebSocket.prototype.toString = function() {
    return this.name + ': ' + this.ipAddress;
};

module.exports = CmdWebSocket;
